import {FiPlus} from "react-icons/fi";
import {Link} from "react-router";

import RUMImage from "@/assets/images/screenshots/rum2-hero-sm.png";
import Button from "@/components/button/Button.tsx";
import {Icon} from "@/components/icon/Icon.tsx";
import {EmptyListView} from "@/components/placeholder/EmptyListView.tsx";
import {MonitoringServiceType} from "@/lib/types/checks.ts";
import {QUERY} from "@/pages/checks/constants.ts";

export const RUMListEmpty = () => (
  <EmptyListView
    title="You are not yet collecting Real User Monitoring data..."
    subtitle="Add a Real User Monitoring check now."
    helpTitle="What is a Real User Monitoring (RUM)?"
    helpSubtitle="RUM collects and compares real-time user data by device, OS, browser, and geography to performance baselines to help optimize for site speed, errors, bounce rates, and more. "
    helpImage={RUMImage}
    helpLinks={[
      {
        link: "https://support.uptime.com/hc/en-us/articles/4415874052242-RUM-Advanced-Data-and-Reports",
        title: "Overview of RUM Checks & Reports",
      },
    ]}
  >
    <Button
      size="large"
      variant="secondary"
      as={Link}
      to={`/checks/create?${QUERY.MONITORING_SERVICE_TYPE}=${MonitoringServiceType.RUM2}`}
    >
      <Icon icon={FiPlus} /> Create RUM Check
    </Button>
  </EmptyListView>
);
